import React from 'react';
import ChevronBottomIcon from "./ChevronBottomIcon.mjs";

const ChevronTopIcon = class extends React.Component {
	render() { return <ChevronBottomIcon style={{transform: "scaleY(-1)", ...(this.props.style||{})}} />; }
}

export default ChevronTopIcon;
